import { useState } from 'react';
import { Button } from '../input';

export const Optional = ({ children, style, hide }) => {
  const [hidden, setHidden] = useState(hide);

  if (hidden) {
    return (
      <div style={{ textAlign: 'left' }}>
        <Button small gray trans onClick={() => setHidden(false)}>
          Show advanced options
        </Button>
      </div>
    );
  }

  return (
    <div style={{ border: '1px solid #ddd', padding: 15, borderRadius: 8 }}>
      <div style={{ fontSize: 12, color: '#777', marginBottom: 5 }}>
        <b>Optional</b>
      </div>
      <div style={style}>{children}</div>
    </div>
  );
};
